import { render } from "./HomeEvent.vue?vue&type=template&id=4e71d348&ts=true"
import script from "./HomeEvent.vue?vue&type=script&lang=ts"
export * from "./HomeEvent.vue?vue&type=script&lang=ts"

import "./HomeEvent.vue?vue&type=style&index=0&id=4e71d348&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__